import { UpdateCarProps } from "declarations/carServices";
import { arePhoneNumbersTheSame, hasMinimumPhoneDigits } from "functions/text";
import { CarType } from "types/loadedData";
import { translateDashboardText } from "i18n/dashboardLanguage";

const EMAIL_REGEX = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;
const TELEGRAM_REGEX =
  /\b(?:telegram|t\.me\/|telegram\.me\/|@[\w]{5,})\b/i;
const PHONE_CANDIDATE_REGEX = /(?:\+?\d[\d\s().-]{7,}\d)/g;

const isEthiopianPhoneNumber = (value = "") => {
  const normalizedValue = value.replace(/[\s().-]/g, "");

  return (
    /^\+2519\d{8}$/.test(normalizedValue) ||
    /^2519\d{8}$/.test(normalizedValue) ||
    /^09\d{8}$/.test(normalizedValue) ||
    /^9\d{8}$/.test(normalizedValue)
  );
};

const containsEthiopianPhoneNumber = (text = "") => {
  const phoneCandidates = text.match(PHONE_CANDIDATE_REGEX) || [];
  return phoneCandidates.some(isEthiopianPhoneNumber);
};

const hasRestrictedContactInfo = (text = "") => {
  if (!text) return false;
  return (
    EMAIL_REGEX.test(text) ||
    containsEthiopianPhoneNumber(text) ||
    TELEGRAM_REGEX.test(text)
  );
};

export const validateUpdateCarData = ({
  data,
}: {
  data: UpdateCarProps;
}): boolean => {
  let errorMessage = "";

  if (!data.model) errorMessage = "model is required";
  else if (!data.year) errorMessage = "Year of manufacturing is requred";
  else if (String(data.year).length !== 4)
    errorMessage = "Year of manufacturing must be 4 characters";
  else if (!data.make) errorMessage = "Make is required";
  else if (!data.price) errorMessage = "Price is required";
  else if (!data.mileage) errorMessage = "Mileage is required";
  else if (!data.transmissionType)
    errorMessage = "Transmission type is required";
  else if (!data.fuelType) errorMessage = "Fuel type is required";
  else if (!data.listingType) errorMessage = "Listing type is required";
  else if (!data.usageType) errorMessage = "Usage type is required";
  else if (!data.phone) errorMessage = "Owner Phone is required";
  else if (!hasMinimumPhoneDigits(data.phone))
    errorMessage = "Owner phone must include at least 6 digits";
  else if (!data.description) errorMessage = "Desciption is required";
  else if (hasRestrictedContactInfo(data.description))
    errorMessage =
      "Description cannot include phone number, email, or Telegram address.";
  else if (data.buyerPhone && data.buyerPhone?.length !== 10)
    errorMessage = "Buyer Phone Number must be 10 digits";

  if (errorMessage) {
    alert(translateDashboardText(errorMessage));
    return false;
  }

  return true;
};
